import {hitAlgolytics} from "@pg-mono/algolytics";

import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/form/application_form_source";
import {ViewType} from "../../view_type/ViewType";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";

const MODAL_STATS_EVENT = "modal_stats";

interface IModalStatsPayload {
    source?: ApplicationSource;
    source_section?: ApplicationSourceSection;
    used: boolean;
    property_id?: number;
    offer_id?: number;
    view_type: ViewType;
    vendor_id?: number;
    modal_version_name: string;
}

export const modalStatsHit = (payload: IModalStatsPayload) => {
    const {site_id} = getTrackedSiteData();
    const eventPayload = {
        ...payload,
        site_id
    };
    hitAlgolytics(MODAL_STATS_EVENT, eventPayload);
};
import {hitAlgolytics} from "@pg-mono/algolytics";

import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/form/application_form_source";
import {ViewType} from "../../view_type/ViewType";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";

const MODAL_STATS_EVENT = "modal_stats";

interface IModalStatsPayload {
    source?: ApplicationSource;
    source_section?: ApplicationSourceSection;
    used: boolean;
    property_id?: number;
    offer_id?: number;
    view_type: ViewType;
    vendor_id?: number;
    modal_version_name: string;
}

export const modalStatsHit = (payload: IModalStatsPayload) => {
    const {site_id} = getTrackedSiteData();
    const eventPayload = {
        ...payload,
        site_id
    };
    hitAlgolytics(MODAL_STATS_EVENT, eventPayload);
};
